{
  "ui": {
    "feedback": "Feedback",
    "credits": "Medvirkende",
    "currentMaintainer": "Nuværende vedligeholder",
    "maintainerPeriod": "Fra 2026 og frem",
    "originalTeam": "Det oprindelige hold",
    "creditsCampaigns": "Jungle og jul",
    "moreSettings": "Flere indstillinger",
    "chooseLanguage": "Vælg dit sprog",
    "notebookTools": "Værktøjer til notesbogen",
    "visualGuide": "Billedvejledning",
    "templeSoon": "Kommer snart",
    "playAdventure": "Spil",
    "story": "Historien",
    "loadingAdventure": "Vi pakker til eventyret…",
    "storyOpening": "En skoleudflugt til junglen. Marco og Sophia går på opdagelse med deres venner. En farverig fugl fanger Marcos blik, og han følger den ind mellem træerne. Pludselig er han alene. Hjælp opdagelsesrejsende med at finde vej!",
    "storyEnding": "Marco og Sophia når sammen frem til det forsvundne tempel. Et mystisk ansigt vogter indgangen. Et nyt eventyr venter!",
    "blockCategories": "Notesbogens faner",
    "actions": "Handlinger",
    "loops": "Løkker",
    "conditions": "Betingelser",
    "title": "Run Marco! — Et eventyr i din notesbog",
    "home": "Run Marco-startside",
    "map": "Eventyrkort",
    "worlds": "Vælg et eventyr",
    "notebook": "Min notesbog",
    "notebookToggle": "Åbn eller luk notesbogen",
    "notebookOpen": "Åbn notesbogen",
    "notebookClose": "Se stien",
    "page": "Side {number}",
    "level": "Rute {number}",
    "run": "Kom så!",
    "stop": "Stop",
    "step": "Ét skridt",
    "stepTitle": "Udfør én instruktion",
    "reset": "Tilbage til start",
    "add": "Tilføj",
    "addLabel": "Vælg en blok at tilføje",
    "addHint": "Sæt blokkene sammen, og tryk på Spil.",
    "undo": "Fortryd",
    "clear": "Ny side",
    "hint": "Et lille tip",
    "help": "Sådan spiller du",
    "settings": "Indstillinger",
    "language": "Spillets sprog",
    "blockLanguage": "Blokkenes sprog",
    "blockLanguageNote": "Du kan vælge et andet sprog til blokkene.",
    "musicOn": "Slå lyden til",
    "musicOff": "Slå lyden fra",
    "sound": "Musik og lydeffekter",
    "speed": "Eventyrets hastighed",
    "chooseExplorer": "Vælg din opdagelsesrejsende",
    "explorer": "Opdagelsesrejsende",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Luk",
    "done": "Lad os udforske!",
    "loading": "Vi finder stien…",
    "loadError": "Eventyret kunne ikke indlæses. Genindlæs siden for at prøve igen.",
    "imageError": "Nogle billeder kunne ikke indlæses. Genindlæs siden.",
    "gemGoal": "Find ædelstenen",
    "goal": "Find den gyldne stjerne",
    "cover": "Tænd hver rude præcis én gang",
    "lit": "{count} / {total} ruder tændt",
    "explored": "{count} / {total} ruter udforsket",
    "facing": "Ser mod {direction} {arrow}",
    "boardLabel": "{name} på {level}, ser mod {direction}. {steps}. {objective}.",
    "up": "op",
    "down": "ned",
    "left": "venstre",
    "right": "højre",
    "steps_one": "{count} skridt",
    "steps_other": "{count} skridt",
    "blocks_one": "{count} blok",
    "blocks_other": "{count} blokke",
    "stars_one": "{count} stjerne",
    "stars_other": "{count} stjerner",
    "place": "Tilføj blokke",
    "atEnd": "Til sidst",
    "insideRepeat": "Inde i gentag {number}",
    "insideIf": "Inde i hvis {number}",
    "insideElse": "Inde i ellers {number}",
    "readyFirst": "Et lille skridt. Tilføj en fremadblok, og kom så!",
    "ready": "Hvor skal vi hen? Lav en plan i notesbogen.",
    "back": "Tilbage ved start. Dine blokke er klar til et nyt forsøg.",
    "empty": "Tilføj først en blok i notesbogen.",
    "win": "Du fandt vej!",
    "winCover": "Du lyste stien op!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Sikke et eventyr!",
    "simpler": "Kan du bruge færre blokke?",
    "complete": "Ruten er klaret! Dine bedste stjerner er gemt.",
    "next": "Næste rute",
    "allWorlds": "Flere eventyr",
    "replay": "Spil igen",
    "shortGoal": "Næsten! Tilføj flere blokke for at nå stjernen.",
    "shortGem": "Næsten! Tilføj flere blokke for at nå ædelstenen.",
    "shortCover": "Nogle ruder er stadig mørke. Hvordan når vi dem?",
    "checking": "Vi ser på stien…",
    "paused": "Stoppet. Spil starter forfra.",
    "going": "Af sted!",
    "stepped": "Et skridt nærmere. Tryk på Ét skridt eller Spil for at fortsætte.",
    "clueCover": "Start ved en kant, og følg hele formen. Et hop springer over en rude uden at tænde den.",
    "clueCondition": "Se på stien foran dig. En betingelse hjælper din opdagelsesrejsende med at vælge en handling.",
    "clueRepeat": "Hvilke skridt gentages? Sæt mønstret ind i en gentagelsesblok.",
    "clueForward": "Fremad følger den retning, din opdagelsesrejsende ser. Tæl ruderne til stjernen.",
    "clueGem": "Fremad følger den retning, din opdagelsesrejsende ser. Tæl ruderne til ædelstenen.",
    "clueTurn": "Et drej ændrer retning uden at flytte dig. Følg stien med fingeren.",
    "mapNote": "Vælg en rute. Dine bedste stjerner bliver gemt.",
    "mapLevel": "Rute {number}: {name}. {stars}.",
    "locked": "Gennemfør den forrige rute for at låse denne op.",
    "soundBlocked": "Tryk på lydknappen for at høre eventyret.",
    "clearTitle": "Begynd på en ny side?",
    "clearNote": "Blokkene til denne rute bliver slettet. Fortryd kan hente dem tilbage.",
    "keep": "Behold mine blokke",
    "clearConfirm": "Slet blokke",
    "fresh": "En ny side. Hvor fører din næste plan os hen?",
    "localProgress": "Dine fremskridt gemmes på denne enhed.",
    "helpBuild": "Lav en plan",
    "helpBuildText": "Træk blokke ind i notesbogen, og forbind dem, eller tryk på en blok for at tilføje den. Vælg »Inde i gentag« for at føje skridt til en løkke.",
    "helpTurn": "Følg din opdagelsesrejsende",
    "helpTurnText": "Fremad følger blikket. Venstre og højre drejer på stedet. Et hop går to ruder frem.",
    "helpTry": "Prøv, se, prøv igen",
    "helpTryText": "Tryk på Spil for din plan eller Ét skridt for én instruktion. Den buede pil går tilbage til start og beholder blokkene.",
    "helpWorlds": "Hvert eventyr har et mål",
    "helpWorldsText": "Find ædelstenen i Junglen. Tænd hver fri flise én gang i juleeventyret. Udfør reparationerne og de viste mål i Templet og Ægæerhavet, og nå udgangen.",
    "noTrail": "Der er ingen sti dér! Prøv at dreje først.",
    "broken": "Broen er ødelagt. Kan du hoppe over den?",
    "blocked": "Noget spærrer vejen. Prøv et hop eller en anden rute.",
    "alreadyLit": "Den rude er allerede tændt. Besøg hver rude kun én gang.",
    "loopError": "Planen gentages uden ende. Prøv at ændre løkken.",
    "repeatError": "Vælg et antal gentagelser fra 1 til 99.",
    "unsupported": "Fjern den blok, der ikke understøttes, og prøv igen.",
    "connect": "Sæt blokkene sammen til én kæde, og tryk på Spil.",
    "path": "sti",
    "backpack": "Rygsæk",
    "templeGems": "Templets ædelsten",
    "gemsCollected": "Ædelsten: {count} / {total}",
    "gemsReady": "Alle ædelsten er samlet!",
    "aegeanTitle": "Det Ægæiske Havs hemmeligheder",
    "harbour": "Havn",
    "aegeanDescription": "Udforsk havnen: reparer stationer, genbrug rutiner, og send et tal med hver opgave.",
    "templeBetaNote": "Beta · Gåder og lektioner er under revision",
    "aegeanBetaNote": "Beta · Havnens første 3 baner",
    "seasonal": "Sæsoneventyr",
    "choosePreview": "Vælg en prøvebane",
    "repairs": "Reparationer",
    "reachExit": "Nå frem til udgangen",
    "taskRequirements": "Missionens mål",
    "lessonGuided": "Guidet øvelse · færdiggør det givne program",
    "lessonRepair": "Fejlfinding · ret det givne program",
    "lessonChallenge": "Udfordring · lav dit eget program",
    "acc_define_parameter": "Rutine",
    "acc_call_argument": "Kald rutine",
    "acc_repeat_parameter": "Gentag med input",
    "parameter": "parameter",
    "argument": "send",
    "callInput": "Dette kalds input",
    "inputWaiting": "Kør programmet eller én instruktion ad gangen for at se det næste input.",
    "argumentMismatch": "En rutine med en parameter kræver et kald med et tal. Uden parameter bruges et almindeligt kald.",
    "unsetParameter": "Brug kun parameteren i den rutine, der modtager den. Parametre er adskilt fra den fælles hukommelse.",
    "memoryObjective": "Tjek reparationsloggen og kravene ved udgangen. Alle programmer, der opfylder dem, accepteres.",
    "gate": "Vejen er spærret. Tjek de ufærdige reparationer.",
    "noPickup": "Stil dig på værktøjet, før du samler det op.",
    "creditLead": "Teamledelse og softwareudvikling",
    "creditArt": "Illustration og kulisser",
    "creditAnimation": "Animation",
    "creditUX": "Design af brugergrænseflade og brugeroplevelse",
    "creditDesign": "Spildesign",
    "creditStory": "Historie",
    "creditAudio": "Musik og lydteknik",
    "lightLamp": "Tænd lampen",
    "oilLamp": "Olielampe",
    "dustyStation": "støvet station",
    "betaLabel": "Beta",
    "noLamp": "Stå på en slukket lampe, før du tænder den.",
    "collected": "Værktøj samlet op · klar til brug",
    "dustyPrompt": "Stå på en støvet station, før du bruger penslen.",
    "lampMissing": "Saml først olielampen op. Kig i rygsækken.",
    "recursiveRoutine": "Denne rutine kalder sig selv. Brug en anden rutine; rekursive kald er endnu ikke tilgængelige."
  },
  "content": {
    "jungle.title": "Jungleekspedition",
    "jungle.description": "Følg stien til det forsvundne tempel.",
    "jungle-1": "Første skridt",
    "jungle-2": "Lidt længere",
    "jungle-3": "Rundt om hjørnet",
    "jungle-4": "Skift retning",
    "jungle-5": "Følg stien",
    "jungle-6": "En ny rute",
    "jungle-7": "Nye stier",
    "jungle-8": "Junglekryds",
    "jungle-9": "Find vej",
    "jungle-10": "Tænk fremad",
    "jungle-11": "Den lange sti",
    "jungle-12": "En snoet rute",
    "jungle-13": "Et modigt spring",
    "jungle-14": "Mønstre dukker op",
    "jungle-15": "Gentag rytmen",
    "jungle-16": "Vælg en sti",
    "jungle-17": "Se før du hopper",
    "jungle-18": "Læs stien",
    "jungle-19": "En smart omvej",
    "jungle-20": "Under trækronerne",
    "jungle-21": "Brobygger",
    "jungle-22": "På den anden side af floden",
    "jungle-23": "Udforsk ruinerne",
    "jungle-24": "Sten og træ",
    "jungle-25": "Et større hop",
    "jungle-26": "Følg sporene",
    "jungle-27": "Højere op",
    "jungle-28": "Bliv ved med at udforske",
    "jungle-29": "Snoede stier",
    "jungle-30": "Den hemmelige have",
    "jungle-31": "Skjulte mønstre",
    "jungle-32": "Gamle stier",
    "jungle-33": "De sidste sving",
    "jungle-34": "Mod templet",
    "jungle-35": "Næsten fremme",
    "jungle-36": "Det forsvundne tempel",
    "winter.title": "Vintersti",
    "winter.description": "Sæt lys i hvert fodspor.",
    "winter-1": "Skridt i sneen",
    "winter-2": "En anden retning",
    "winter-3": "Frosne hjørner",
    "winter-4": "Den lange omvej",
    "winter-5": "Snefnug",
    "winter-6": "Vinterløkker",
    "winter-7": "Isopdager",
    "winter-8": "Sving og drej",
    "winter-9": "Iskold logik",
    "winter-10": "Mønsterfinder",
    "winter-11": "Stiens mester",
    "winter-12": "Vintervidunder",
    "temple.title": "Det forsvundne tempel",
    "temple.description": "Fyrre sammenhængende rum. Gendan et himmelinstrument med værktøjer, hukommelse og egne rutiner."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Papirkurven er tom",
    "OPEN_TRASH": "Åbn papirkurven",
    "BLOCK_LABEL_BEGIN_STACK": "Start på stak",
    "WORKSPACE_LABEL_1_STACK": "1 stak blokke",
    "WORKSPACE_LABEL_MANY_STACKS": "%1 stakke blokke",
    "ARIA_TYPE_FIELD_NUMBER": "tal",
    "ARIA_TYPE_FIELD_DROPDOWN": "rulleliste",
    "ARIA_TYPE_FIELD_IMAGE": "billede",
    "WORKSPACE_LABEL_PLAIN": "Min notesbog",
    "FIELD_LABEL_EDIT_PREFIX": "Rediger %1",
    "BLOCK_LABEL_HAS_INPUT": "har input",
    "BLOCK_LABEL_HAS_INPUTS": "har flere input",
    "BLOCK_LABEL_HAS_BRANCHES": "har %1 grene",
    "FIELD_LABEL_OPTION_INDEX": "Valg %1",
    "INPUT_LABEL_EMPTY": "Tom",
    "BLOCK_LABEL_DISABLED": "deaktiveret",
    "BLOCK_LABEL_COLLAPSED": "foldet sammen",
    "BLOCK_LABEL_BEGIN_PREFIX": "Start: %1",
    "INPUT_LABEL_END_STATEMENT": "Slut: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "tekst",
    "ARIA_TYPE_FIELD_INPUT": "input",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "inputnavn",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "rutinenavn"
  }
}
